<template>
  <div>
    <div v-if="isLoading" class="loading">Loading&#8230;</div>
    <table v-if="items.length >0" class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">cid</th>
          <th scope="col">Full Name</th>
          <th scope="col">Total</th>
          <th scope="col">Coupon code</th>
          <th scope="col">Expire</th>
          <th scope="col">Redeem</th>
        </tr>
      </thead>
      <tbody>
        <tr :class="rowClass(item,'row')" v-for="(item,index) in items" :key="index">
          <td>{{index+1}}</td>
          <td>{{item.cid}}</td>
          <td>{{item.newFullName}}</td>
          <td>{{item.total}}</td>
          <td>{{item.couponCode}}</td>
          <td>{{item.couponExpireOn}}</td>
          <td>{{item.isRedeem}}</td>
        </tr>
      </tbody>
    </table>
    <h3 v-else class="no_data">No records found!</h3>
  </div>
</template>

<script>
import axios from "axios";
import { URL_BASE } from "../../../helper/constant";

export default {
  data() {
    return {
      isLoading: true,
      items: []
    };
  },
  created: function() {
    this.getCouponeDetails();
  },
  methods: {
    getCouponeDetails() {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      axios
        .post(`${URL_BASE}/couponlist`)
        .then(result => {
          if (result.data.status && result.data.Records.length > 0) {
            let users = [];

            result.data.Records.map(x => {
              x.couponExpireOn =
                new Date(x.couponExpireOn).getDate() +
                "-" +
                months[new Date(x.couponExpireOn).getMonth()] +
                "-" +
                new Date(x.couponExpireOn).getFullYear();
              let _users = x.users;
              if (_users.Twitter.twitter_screen_name !== "") {
                x.newFullName = _users.Twitter.twitter_screen_name;
              } else if (
                _users.Facebook.facebook_first_name !== "" ||
                _users.Facebook.facebook_last_name !== ""
              ) {
                x.newFullName = `${_users.Facebook.facebook_first_name} ${_users.Facebook.facebook_last_name}`;
              } else if (
                _users.Linkedin.linkedin_first_name !== "" ||
                _users.Linkedin.linkedin_last_name !== ""
              ) {
                x.newFullName = `${_users.Linkedin.linkedin_first_name} ${_users.Linkedin.linkedin_last_name}`;
              } else if (_users.Instagram.instagram_username !== "") {
                x.newFullName = `${_users.Instagram.instagram_username}`;
              } else {
                x.newFullName = "Not found";
              }

              users.push(x);
            });
            this.items = users;
            this.isLoading = false;
            // console.log("users", users);
          } else {
            this.isLoading = false;
          }
        })
        .catch(error => console.log("error", error));
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.isRedeem) return "table-success";
      if (!item.isRedeem) return "table-danger";
    }
  }
};
</script>

<style >
.table-success {
  background-color: #c3e6cb;
  /* background-color: #5cb85c; */
}

.table-danger {
  /* background-color: #c9302c; */
  background-color: #c27976;
}

.no_data {
  text-align: center;
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));

  background: -webkit-radial-gradient(
    rgba(20, 20, 20, 0.8),
    rgba(0, 0, 0, 0.8)
  );
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 150ms infinite linear;
  -moz-animation: spinner 150ms infinite linear;
  -ms-animation: spinner 150ms infinite linear;
  -o-animation: spinner 150ms infinite linear;
  animation: spinner 150ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,
    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,
    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,
    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,
    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/view/userCoupon/couponCode.vue